import { State } from './types'

export const initialState: State = {
  tileQueryParams: '',
  pointsSvgContainer: undefined,
  isEnablePropertiesPoints: true,
  loadedPoints: [],
  loadedStackeds: [],
  loadedClusters: [],
  hoveredOffMarketPoint: undefined,
}
